import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              Trusted Learning Platform
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              Everything You Need To Master BaseTao Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              From beginner tutorials to advanced automation techniques, our comprehensive platform covers every aspect of BaseTao Spreadsheet. Access in-depth guides, practical templates, comparison charts, and expert reviews — all designed to help you work smarter and faster.
            </p>

            <div className="space-y-4 mb-8">
              {[
                { icon: 'ri-book-open-line', title: 'Step-by-Step Tutorials', desc: 'Learn formulas, functions, and productivity techniques from scratch' },
                { icon: 'ri-file-copy-line', title: 'Ready-to-Use Templates', desc: 'Download practical spreadsheet templates for business and personal use' },
                { icon: 'ri-settings-3-line', title: 'Advanced Automation', desc: 'Improve workflow efficiency with powerful automation strategies' },
                { icon: 'ri-scales-line', title: 'Comparison Guides', desc: 'Understand how BaseTao Spreadsheet compares with other tools' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-sm text-primary-600`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-0.5">{item.title}</h4>
                    <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/basetao-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Complete Guides
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20learning%20environment%20with%20an%20open%20notebook%20filled%20with%20colorful%20spreadsheet%20notes%20and%20hand%20drawn%20diagrams%20on%20a%20light%20wooden%20desk%2C%20surrounded%20by%20office%20supplies%20neatly%20arranged%2C%20a%20tablet%20displaying%20data%20charts%20leaning%20against%20a%20stack%20of%20books%2C%20soft%20warm%20afternoon%20sunlight%20casting%20gentle%20shadows%20through%20sheer%20curtains%2C%20sage%20green%20and%20cream%20color%20palette%2C%20scandinavian%20study%20aesthetic%2C%20editorial%20education%20photography%2C%20calm%20and%20focused%20atmosphere&width=800&height=600&seq=cta-learning-v2-2026&orientation=landscape"
                alt="BaseTao Spreadsheet learning dashboard on laptop"
                title="BaseTao Spreadsheet learning environment"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}